import { RefreshReminder } from './RefreshReminder';
import payLaterIllustrationSvg from './payLaterIllustration.svg';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import styles from './SpendingLimitView.module.css';

function SpendingLimitView({ creditLimit }: { creditLimit: number | null }) {
    return (
        <div className={styles.viewContainer}>
            <div className={styles.view}>
                <div
                    className={styles.heading}
                    data-testid="spending-limit-heading"
                >
                    Here's how to use your{' '}
                    <FormattedCurrency value={creditLimit!} /> spending limit:
                </div>
                <div className={styles.gridContainer}>
                    <div className={styles.circle}>1</div>
                    <div className={styles.stepItem}>
                        Choose to pay with 'Pay Later' from iwocaPay - with any
                        iwocaPay supplier at their checkout or via a link on
                        their invoice
                    </div>
                    <div className={styles.circle}>2</div>
                    <div className={styles.stepItem}>
                        Sign into your iwocaPay account - your spending limit
                        will be automatically applied
                        <div className={styles.illustrationImg}>
                            <img
                                src={payLaterIllustrationSvg}
                                alt="Pay Later Illustration"
                            />
                        </div>
                    </div>
                    <div className={styles.circle}>3</div>
                    <div className={styles.stepItem}>
                        Finish checking out as normal - your supplier gets paid
                        instantly, you spread the cost over manageable monthly
                        payments
                    </div>
                </div>
                <RefreshReminder />
            </div>
        </div>
    );
}

// eslint-disable-next-line import/no-default-export
export default SpendingLimitView;
